// SharedFormFields.jsx
// Reusable fields that behave differently in Add vs Edit.
// Import these into all 4 forms instead of repeating isAdd logic everywhere.

import { Autocomplete, Grid, InputLabel, TextField } from '@mui/material';
import React from 'react';
import InputFields from 'routes/Pages/components/InputFields/InputFields';
import { useAllUsers } from 'context/AllUserDataContext';
import moment from 'moment';

const dropDownStyles = {
  paddingBottom: '10px',
  fontSize: '0.825rem',
  color: 'black',
};

const autoCompleteSlotProps = {
  paper: {
    sx: {
      '& .MuiAutocomplete-option': {
        fontSize: '0.82rem',
        fontWeight: 500,
      },
    },
  },
};

// ── Employee Name ─────────────────────────────────────────────────────────────
// isAdd=true  → Autocomplete from allUsers
// isAdd=false → read-only text (already set on the record)
export const EmployeeNameField = ({ value, onChange, isAdd = true, isOperator = false }) => {
  const { allUsers } = useAllUsers();

  console.log('allUsers', allUsers);
  const employeeOptions = Array.isArray(allUsers)
    ? allUsers
        .filter(u => u.roleId === 1 || u.roleId === 4 || (isOperator ? u.roleId === 2 : u.roleId === 3))
        .map(u => u.defaultDriverDisplayName || u.email || '')
        .filter(Boolean)
    : [];

  if (!isAdd) {
    return (
      <InputFields
        label="Employee Name"
        name="employeeName"
        required={true}
        value={value}
        textFieldType="text"
        width={4}
        handleIpChange={onChange}
        disabled={true}
      />
    );
  }

  return (
    <Grid item xs={12} sm={6} md={4}>
      <InputLabel size="small" sx={dropDownStyles} required>
        Employee Name
      </InputLabel>
      <Autocomplete
        size="small"
        disablePortal
        options={employeeOptions}
        value={value || null}
        onChange={(_, newValue) => onChange('employeeName', newValue || '')}
        renderInput={params => <TextField required {...params} size="small" fullWidth placeholder="Search employee..." />}
        fullWidth
        slotProps={{ ...autoCompleteSlotProps }}
      />
    </Grid>
  );
};

// ── Date & Time ───────────────────────────────────────────────────────────────

const toLocalDateTimeInput = dateString => {
  if (!dateString) return '';
  return moment(dateString).format('YYYY-MM-DDTHH:mm');
};

export const DateTimeField = ({ value, onChange, isAdd }) => {
  const localValue = toLocalDateTimeInput(value);
  if (!isAdd) {
    return (
      <InputFields
        label="Date & Time"
        name="dateAndTime"
        required={true}
        value={localValue}
        textFieldType="datetime-local"
        width={4}
        handleIpChange={onChange}
      />
    );
  }

  return (
    <Grid item xs={12} sm={6} md={4}>
      <InputLabel size="small" sx={dropDownStyles} required>
        Date &amp; Time
      </InputLabel>
      <TextField
        required
        type="datetime-local"
        size="small"
        fullWidth
        value={localValue || ''}
        onChange={e => onChange('dateAndTime', e.target.value)}
        InputLabelProps={{ shrink: true }}
      />
    </Grid>
  );
};

// Sending Data as is ==========
export const toLocalISO = (date = new Date()) => {
  const d = new Date(date);

  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};
// =============================

export const dateTemplate = (col, data) => {
  if (!col?.field || !data?.[col.field]) return '';

  const value = data[col.field];

  return value.endsWith?.('Z')
    ? moment
        .utc(value)
        .local(true)
        .format('YY/MM/DD, hh:mm')
    : moment(value).format('DD/MM/YY, HH:mm');
};
